<template>
  <v-app-bar
    dense
    fixed
    color="white"
    class="px-0 py-1"
    style="height: auto; z-index: 4; box-shadow: 0px 1px 4px 0px rgba(113, 128, 150, 0.12), 0px 2px 2px 0px rgba(113, 128, 150, 0.14);"
  >
    <v-row class="ma-0 pa-0">
      <v-col cols="2" class="d-flex align-center justify-start">
        <v-icon
          v-if="showBackButton"
          class="ma-0 pa-0"
          color="grey"
          @click="$emit('handleBack')"
        >
          mdi-arrow-left
        </v-icon>

        <v-icon
          v-if="showRefreshButton"
          class="ma-0 pa-0"
          color="grey"
          @click="$emit('handleRefresh')"
        >
          mdi-refresh
        </v-icon>
      </v-col>
      <v-col v-if="title" cols="8" class="d-flex align-center justify-start">
        <p
          class="text-subtitle-2 blue-grey--text text--darken-3 font-weight-bold mb-0"
        >
          {{ title }}
        </p>
      </v-col>
      <v-col v-else cols="8" class="d-flex align-center justify-center">
        <img :src="logo" height="23" />
      </v-col>
      <v-col cols="2" class="d-flex align-center justify-end">
        <Menu :options="menuOptions" @click="handleMenuClick">
          <template v-slot:activator="{ on }">
            <v-btn
              data-testid="topBar-button-gear"
              v-on="on"
              elevation="0"
              fab
              small
              plain
            >
              <v-icon color="blue-grey darken-3">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
        </Menu>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import Menu from '@/ui/shared/components/Menu.vue'
import Logo from '@/assets/logo.svg'
import store from '@/store/index.js'

export default {
  name: 'Header',

  components: { Menu },

  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
    showRefreshButton: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      host: window.Office.context.host,
      logo: Logo,
      helpCenterLink:
        'http://help.reverscore.net/en/articles/6496251-office-add-in',
      menuOptions: [
        {
          icon: 'mdi-help-circle-outline',
          id: 'help',
          title: this.$t('common.help_center'),
          tourId: 'userMenu-option-help',
        },
        {
          icon: 'mdi-logout-variant',
          id: 'logout',
          tourId: 'userMenu-option-logOut',
          title: this.$t('common.log_out'),
        },
      ],
    }
  },

  methods: {
    handleMenuClick(option) {
      switch (option.id) {
        case 'logout': {
          return this.logout()
        }
        case 'help': {
          this.$track('msOffice.helpCenter', {
            env: window.Office.context.host,
          })

          return (
            window?.Office?.context?.ui?.openBrowserWindow?.(
              this.helpCenterLink
            ) || window?.open?.(this.helpCenterLink)
          )
        }
      }
    },

    logout() {
      try {
        store.access.logout()
        return this.$router.push({ path: '/' })
      } catch (err) {
        console.log('Error on syncSession', err)
      }
    },
  },
}
</script>
